import Impressum from '../pages/impressum/Impressum';
import Project from '../pages/project/Project';
import Home from '../pages/home/Home';

export const AppRoutes = [
	{ name: 'Home', path: '*', component: Home },
	{ name: 'Project', path: 'project/:id', component: Project },
	{ name: 'Impressum', path: '/impressum', component: Impressum },
];
